import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MenuModel } from '../models/menu.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ComunService {
  private menuJsonUrl = 'assets/json/menu-data.json';
  private urlServiceAdmin = environment.API_SERVICES_ADMIN;
  private urlServiceGeo = environment.API_SERVICES_GEO;
  urlUbigeos = `${this.urlServiceAdmin}/api/ubigeo`;
  urlUbigeosFiltrados = `${this.urlServiceAdmin}/api/ubigeo-filtered`;
  urlNational = `${this.urlServiceAdmin}/api/national-forest`;
  urlDominios = `${this.urlServiceAdmin}/api/domain`;
  urlRoles = `${this.urlServiceAdmin}/api/protected/role`;

  constructor(private http: HttpClient) {}

  getMenu() {
    return this.http.get<MenuModel[]>(this.menuJsonUrl);
  }

  getDominios(schema: string, table: string, field: string) {
    return this.http.get<any[]>(`${this.urlServiceAdmin}/api/geo-domain?geoDomainSchema=${schema}&geoDomainTable=${table}&geoDomainField=${field}`);
  }

  getGeoDominios(schema: string, table: string, field: string) {
    return this.http.get<any[]>(`${this.urlServiceAdmin}/api/geo-domain/geo-domain?geoDomainSchema=${schema}&geoDomainTable=${table}&geoDomainField=${field}`);
  }

  getDepartamentos() {
    return this.http.get<any[]>(`${this.urlUbigeos}/department-list`);
  }

  getDepartamentosWet() {
    return this.http.get<any[]>(`${this.urlNational}/wet-department-list`);
  }

  getDepartamentosDry() {
    return this.http.get<any[]>(`${this.urlNational}/dry-department-list`);
  }

  getProvincias(departmentId: string) {
    return this.http.get<any[]>(
      `${this.urlUbigeos}/province-list?departmentId=${departmentId}`
    );
  }

  getProvinciasWet(departmentId: string) {
    return this.http.get<any[]>(`${this.urlNational}/wet-province-list?departmentId=${departmentId}`);
  }

  getProvinciasDry(departmentId: string) {
    return this.http.get<any[]>(`${this.urlNational}/dry-province-list?departmentId=${departmentId}`);
  }

  getDistritos(departmentId: string, provinceId: string) {
    return this.http.get<any[]>(
      `${this.urlUbigeos}/district-list?departmentId=${departmentId}&provinceId=${provinceId}`
    );
  }

  getDistritosWet(departmentId: string, provinceId: string) {
    return this.http.get<any[]>(
      `${this.urlNational}/wet-district-list?departmentId=${departmentId}&provinceId=${provinceId}`
    );
  }

  getDistritosDry(departmentId: string, provinceId: string) {
    return this.http.get<any[]>(
      `${this.urlNational}/dry-district-list?departmentId=${departmentId}&provinceId=${provinceId}`
    );
  }

  getAreasNaturalesProtegidas() {
    return this.http.get<any[]>(`${this.urlNational}/protected-national-area-list`);
  }

  getAreasNaturalesProtegidasFiltrado() {
    return this.http.get<any[]>(`${this.urlUbigeosFiltrados}/protected-national-area-list`);
  }

  getZonas() {
    return this.http.get<any[]>(`${this.urlNational}/buffer-zone-list`);
  }

  getZonasFiltrado() {
    return this.http.get<any[]>(`${this.urlUbigeosFiltrados}/buffer-zone-list`);
  }

  getDominiosSecurity(typeDomain: string, typeTable: string) {
    return this.http.get<any[]>(`${this.urlDominios}?typeDomain=${typeDomain}&typeTable=${typeTable}`);
  }


  getDepartamentosAlerta() {
    return this.http.get<any[]>(`${this.urlServiceAdmin}/api/ubigeo-filtered/department-list-early-alert`);
  }

  getProvinciasAlerta(codeDepa: string) {
    return this.http.get<any[]>(`${this.urlServiceAdmin}/api/ubigeo-filtered/province-list-early-alert?departmentId=${codeDepa}`);
  }

  getDistritosAlerta(codeDepa: string, codeProv: string) {
    return this.http.get<any[]>(`${this.urlServiceAdmin}/api/ubigeo-filtered/district-list-early-alert?departmentId=${codeDepa}&provinceId=${codeProv}`);
  }

  getDepartamentosCambioUso() {
    return this.http.get<any[]>(`${this.urlUbigeosFiltrados}/department-list-land-use`);
  }

  getProvinciasCambioUso(codeDepa: string) {
    return this.http.get<any[]>(`${this.urlUbigeosFiltrados}/province-list-land-use?departmentId=${codeDepa}`);
  }

  getDistritosCambioUso(codeDepa: string, codeProv: string) {
    return this.http.get<any[]>(`${this.urlUbigeosFiltrados}/district-list-land-use?departmentId=${codeDepa}&provinceId=${codeProv}`);
  }

  getRolesPorTipo(typeId: number) {
    return this.http.get<any>(`${this.urlRoles}?typeId=${typeId}`);
  }
}
